// const url = "https://cl-api.docsun.health/api/"

// const url = "https://cl-api.docsun.health/api/" //< --clinical server
// const url = "https://diagnostic-api.bostonresearch.ai/api/" <-- api for boston research
// const url = "https://api.docsun.health/api/" //<-- prod api
// const url = "https://26d4-105-163-188-157.ngrok.io/api/" //<-- test api
const url = "https://diagnostic-api-test.bostonresearch.ai/api/" //<-- test api

export default url